module.exports = {
	"name": "Biomes",
	"desc": "Communities of plants and animals defined by their climate and dominant vegetation.",
	"useHighResMaps": true,
	"maps": [
		{
			"name": "biomes",
			"displayName": "Biomes"
		}
	],
	"legendCells": [
		{
			"name": "Tropical Rain Forest",
			"style": "tropical-rain-forest",
			"desc": "With high year-round temperatures and high annual rainfall, this biome is found in areas throughout the tropical zone and supports rapid tree growth and high species diversity."
		},
		{
			"name": "Tropical Dry Forest",
			"style": "tropical-dry-forest",
			"desc": "This biome is characterized by warm, even temperatures and high annual rainfall interrupted by months of drought during which deciduous trees shed their leaves to conserve water."
		},
		{
			"name": "Savanna",
			"style": "savanna",
			"desc": "With warm temperatures and seasonal rainfall, this biome consists of a mixture grasses and sparse trees and is found within tropical and subtropical latitudes."
		},
		{
			"name": "Desert",
			"style": "desert",
			"desc": "With dry, treeless landscapes receiving less than 25 centimeters of rainfall annually, this biome may be characterized by extreme diurnal temperature variations."
		},
		{
			"name": "Chaparral",
			"style": "chaparral",
			"desc": "One of the rarest biomes, it is found primarily in coastal regions and experiencing hot, dry summers and cool, moist winters."
		},
		{
			"name": "Temperate Grassland",
			"style": "temperate-grassland",
			"desc": "Known regionally as prairie, pampas, veld, or steppe, this biome is largely devoid of trees and has large seasonal variability in temperatures but relatively low precipitation."
		},
		{
			"name": "Temperate Deciduous Forest",
			"style": "temperate-deciduous-forest",
			"desc": "This biome has wide variations in temperature and precipitation with vegetation comprising four vertical layers: mature canopy, juvenile canopy, shrubs, and herbs."
		},
		{
			"name": "Temperate Coniferous Forest",
			"style": "temperate-coniferous-forest",
			"desc": "This biome has warm summers and cool winters and occurs where there is adequate rainfall to support an evergreen forest. Depending on geography and the local climate, the forest can range from fairly dry to extremely wet."
		},
		{
			"name": "Boreal Forest",
			"style": "boreal-forest",
			"desc": "Located in high latitudes between 50 and 60 degrees, this biome is characterized by low precipitation, low species diversity, and low annual temperatures that promote permafrost."
		},
		{
			"name": "Tundra",
			"style": "tundra",
			"desc": "A frozen, treeless, desert located between 60 and 70 degrees latitude, this biome is characterized by sparse vegetation and months of no sunlight."
		},
		{
			"name": "Alpine",
			"style": "alpine",
			"desc": "This biome is characterized by high altitude grassland and shrubland regions spanning most latitudes and supporting vegetation adapted to intense sunlight exposure."
		},
		{
			"name": "Polar Ice",
			"style": "polar-ice",
			"desc": "Consisting of unvegetated regions covered in ice, close to the Earth’s poles, this biome does not support wildlife."
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/resources/data/biome-info.json
// module id = 1151
// module chunks = 0